<template>
	<fieldset>
		<div class="h1-buttons col-12 mb-0">
			<h3>{{ title }}</h3>
			<div class="my-2">
				<button class="btn btn-secondary" @click="$emit('none')">Keep LOCAL</button>
				<button class="btn btn-secondary" @click="$emit('all')">Apply REMOTE</button>
				<button class="btn btn-secondary" v-if="title == 'hyper-dispatch'" @click="$emit('left')">Merge into LOCAL</button>
				<button class="btn btn-secondary"  v-if="title == 'hyper-dispatch'" @click="$emit('right')">Merge into REMOTE</button>
				<button class="btn btn-secondary" @click="collapsed=!collapsed">
					<i v-bind:class="{'fas fa-chevron-up':!collapsed, 'fas fa-chevron-down':collapsed}"></i></button>
			</div>
		</div>
		<div v-show="!collapsed">
			<slot></slot>
		</div>
	</fieldset>
</template>

<script>


export default {
	name: "ImporterFrame",
	props: ["title"],
	data() {
		return {
			collapsed: false
		};
	},
	methods: {		
		close() {
			this.$refs.gitImportEverythingModal.hide();	
		},
	}

};
</script>

<style scoped>
	.importer-frame-container {
		margin-top: 5rem;
	}
</style>